export class TnError<T = unknown> extends Error {
    // TODO: deprecate type in favor of unique error classes and typeof
    public type = '';
    public data: T;

    constructor(message: string, data: T) {
        super(message);
        this.data = data;
    }
}